
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.445.25a1.11 1.11 0 011.112 1.111v1.112h4.445V1.36a1.11 1.11 0 112.222 0v1.112h1.667c.92 0 1.667.746 1.667 1.667v1.667H0V4.14c0-.92.747-1.667 1.667-1.667h1.667V1.36A1.11 1.11 0 014.445.25zM0 6.918h15.558v1.514l-5.511 5.511a2.222 2.222 0 00-.584 1.032l-.52 2.087c-.08.326-.063.66.048.965H1.667C.747 18.027 0 17.281 0 16.36V6.918zm4.167 2.778a.832.832 0 00-.833.834c0 .461.371.833.833.833h5.001a.831.831 0 00.834-.833.831.831 0 00-.834-.834h-5zm-.833 4.168c0 .461.371.833.833.833h2.779a.831.831 0 00.833-.833.831.831 0 00-.833-.834H4.167a.831.831 0 00-.833.834zm15.76-5.429l.5.5c.541.542.541 1.42 0 1.966l-1.021 1.021-2.466-2.466 1.021-1.02a1.392 1.392 0 011.966 0zm-8.262 6.297l4.487-4.487 2.465 2.466-4.487 4.483a1.1 1.1 0 01-.517.292l-2.087.52a.55.55 0 01-.528-.145.55.55 0 01-.146-.528l.521-2.087c.049-.195.15-.375.292-.518v.004z"}})])
          )
        }
      }
    